import {css} from '@emotion/react'
import StartpageLogoNew from '../../../../images/4624/startpage-logo.svg'
import SuccessArrow from '../../../../images/4624/success-arrow.svg'

const Header = ({languageCode}) => {
    const translations = {
        en: {
            callout: 'Start searching in private now!',
        },
        de: {
            callout: 'Jetzt privat suchen!',
        },
        nl: {
            callout: 'Zoek privé nu!',
        },
        fr: {
            callout: 'Recherchez en privé maintenant!',
        },
    }

    const text = translations[languageCode]

    return (
        <div
            className="header-success"
            css={css`
                padding: 20px 1rem;
            `}
        >
            <div
                className="inner"
                css={css`
                    max-width: 1150px;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                `}
            >
                <a
                    href={`https://www.startpage.com${
                        typeof window !== 'undefined' && window.location.href.match('/de') ? '/de' : ''
                    }`}
                    rel="noopener noreferrer"
                >
                    <StartpageLogoNew
                        alt="home"
                        css={css`
                            width: 192px;
                        `}
                    />
                </a>
                <div className="callout">
                    <SuccessArrow />
                    <span
                        className="callout-text"
                        css={css`
                            margin-left: 16px;
                            font-weight: 700;
                        `}
                    >
                        {text.callout}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Header
